import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Box, Toolbar, Typography } from '@material-ui/core';
import { baseName } from 'config/keys';
const logoUri = `${baseName}/images/logos/logo_dscont_whiteH50.png`;

const useStyles = makeStyles(() => ({
   root: {
      boxShadow: 'none'
   }
}));

const Topbar = props => {
   const { className, ...rest } = props;

   const classes = useStyles();

   return (
      <AppBar {...rest} className={clsx(classes.root, className)} color="primary" position="fixed">
         <Toolbar>
            <RouterLink to="/">
               <img alt="Logo" src={logoUri} />
            </RouterLink>
            <div style={{ flexGrow: 1 }}>
               <Typography style={{ color: 'white', textAlign: 'center', marginRight: '180px' }} variant="h4"> Intranet Clientes</Typography>
            </div>
         </Toolbar>
      </AppBar>
   );
};

Topbar.propTypes = {
   className: PropTypes.string
};

export default Topbar;
